module.exports = __webpack_public_path__ + "static/Ottawa-Painting-1024x768-8db4110f1fc168e5638ae8314b6e93ea.jpg";